import React from 'react';
import { useHistory } from 'react-router-dom';
import { customAxiosPostFunction } from 'utils/axiosFunction';

import { ModuleStatusPopupContainer, ModuleStatusPopupBox } from './ModuleStatusPopup.css.js';
import status_legend_icon_blue from 'static/images/icon/status_legend_icon_blue.png';
import module_status_icon_fix from 'static/images/icon/module_status_icon_fix.png';
import module_status_icon_cali from 'static/images/icon/module_status_icon_cali.png';

const ModuleStatusPopup = ({ xcoordinate, ycoordinate, setStatusPopupOn, status, moduleIdx }) => {
  const history = useHistory();
  const handleClick = (selectStatus) => {
    if (selectStatus === status) {
      return false;
    }

    customAxiosPostFunction(history, '/api/module/update/status', { moduleIdx: moduleIdx, status: selectStatus })
      .then((response) => {
        alert('장치상태가 변경되었습니다');
        setStatusPopupOn(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <ModuleStatusPopupContainer
      xcoordinate={xcoordinate > 1100 ? xcoordinate - 200 : xcoordinate + 80}
      ycoordinate={ycoordinate > 500 ? ycoordinate - 140 : ycoordinate}
      status={status}
    >
      <ModuleStatusPopupBox
        status={status === 'blue'}
        onClick={() => {
          handleClick('blue');
        }}
      >
        <div className="icon">
          <img src={status_legend_icon_blue} alt="blue" />
        </div>
        <div className="name">정상</div>
      </ModuleStatusPopupBox>
      <ModuleStatusPopupBox
        status={status === 'fix'}
        onClick={() => {
          handleClick('fix');
        }}
      >
        <div className="icon">
          <img src={module_status_icon_fix} alt="fix" />
        </div>
        <div className="name">고장</div>
      </ModuleStatusPopupBox>
      <ModuleStatusPopupBox
        status={status === 'cali'}
        onClick={() => {
          handleClick('cali');
        }}
      >
        <div className="icon">
          <img src={module_status_icon_cali} alt="cali" />
        </div>
        <div className="name">교정중</div>
      </ModuleStatusPopupBox>
    </ModuleStatusPopupContainer>
  );
};

export default ModuleStatusPopup;
